export enum RecoveryRequestSteps {
  Request = 'REQUEST',
  Success = 'SUCCESS',
}
